<template>
  <v-card color="white" flat>
    <v-layout row wrap>
      <v-flex xs12 sm4 class="hidden-sm-and-up">
        <v-card flat>
          <v-layout row wrap class="ma-2" justify-space-between>
            <v-flex xs12 class="pa-2 bordernone mt-2">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                locale="de-DE"
                transition="scale-transition"
                offset-y
                full-width
                min-width="400px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFrom"
                    label="Datum"
                    readonly
                    color="#6f6f6e"
                    class="my-input  pr-2 pt-0 textblock pt-4 px-3"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable
                               v-model="dateFromPS" locale="de-DE" @input="menu1 = false"
                               @change="onChangeFrom"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 class="pa-2 bordernone mt-2">
              <v-select
                :items="hours"
                color="#6f6f6e"
                v-model="hour"
                class="my-input  pr-2 pt-0 textblock pt-4 px-3"
                label="Stunde"
              ></v-select>
            </v-flex>
            <v-flex xs6 class="pa-2 bordernone mt-2">
              <v-select
                :items="minutes"
                color="#6f6f6e"
                v-model="minute"
                class="my-input  pr-2 pt-0 textblock pt-4 px-3"
                label="Minute"
              ></v-select>
            </v-flex>
            <v-flex xs12 class="pa-2">
              <v-text-field solo label="Beschreibung" v-model="historyText" @keyup="keyUpHistory" clearable color="#6f6f6e"></v-text-field>
            </v-flex>
            <v-flex xs12 class="pa-2">
              <v-btn small outline color="#6f6f6e" dark @click="addHistory()" :disabled="lock" block>
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8 class="hidden-sm-and-up">
        <v-card flat>
          <v-card-text class="scroll" v-if="currentItem">
            <v-data-table
              :headers="headerHistory"
              :pagination.sync="pageSync"
              hide-actions
              :items="currentItem.history"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left pa-2" v-for="(head, hi) in headerHistory" valign="top" v-bind:key="hi">
                    <div v-if="head.type === 'i18nTitle'">
                      <span class="cTitle">{{ translate(props.item.title) }}</span>
                    </div>
                    <div v-if="head.type === 'date'" class="text-center">
                      <span>{{ getDateTime(props.item.created) }}</span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="hidden-xs-only">
        <v-card flat>
          <v-layout row wrap class="ma-2" justify-space-between>
            <v-flex md1 class="pa-2 bordernone mt-2">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                locale="de-DE"
                transition="scale-transition"
                offset-y
                full-width
                min-width="400px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFrom"
                    label="Datum"
                    readonly
                    color="#6f6f6e"
                    class="my-input  pr-2 pt-0 textblock pt-4 px-3"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable
                               v-model="dateFromPS" locale="de-DE" @input="menu1 = false"
                               @change="onChangeFrom"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md1 class="pa-2 bordernone mt-2">
              <v-select
                :items="hours"
                color="#6f6f6e"
                v-model="hour"
                class="my-input  pr-2 pt-0 textblock pt-4 px-3"
                label="Stunde"
              ></v-select>
            </v-flex>
            <v-flex md1 class="pa-2 bordernone mt-2">
              <v-select
                :items="minutes"
                color="#6f6f6e"
                v-model="minute"
                class="my-input  pr-2 pt-0 textblock pt-4 px-3"
                label="Minute"
              ></v-select>
            </v-flex>
            <v-flex md7 class="pa-2 mt-4">
              <v-text-field solo label="Beschreibung" v-model="historyText" @keyup="keyUpHistory" clearable color="#6f6f6e"></v-text-field>
            </v-flex>
            <v-flex md1 class="pa-2 mt-4">
              <v-btn small outline color="#6f6f6e" dark @click="addHistory()" :disabled="lock">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="hidden-xs-only">
        <v-card flat>
          <v-card-text class="scroll" v-if="currentItem">
            <v-data-table
              :headers="headerHistory"
              :pagination.sync="pageSync"
              hide-actions
              :items="currentItem.history"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left pa-2" v-for="(head, hi) in headerHistory" valign="top" v-bind:key="hi">
                    <div v-if="head.type === 'i18nTitle'">
                      <span class="cTitle">{{ translate(props.item.title) }}</span>
                    </div>
                    <div v-if="head.type === 'date'" class="text-center">
                      <span>{{ getDateTime(props.item.created) }}</span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
export default {
  name: 'TabHistory',
  data () {
    return {
      lock: false,
      menu1: false,
      currentItem: null,
      dateFrom: '',
      dateFromObj: new Date(),
      dateFromPS: '',
      isLoading: false,
      hours: [],
      historyText: '',
      minutes: [],
      hour: 13,
      minute: 0,
      pageSync: {
        descending: true,
        page: 0,
        rowsPerPage: -1,
        sortBy: 'created',
        totalItems: -1
      },
      headerHistory: [
        {
          text: 'Datum',
          align: 'left',
          class: 'text-xs-center',
          value: 'created',
          type: 'date',
          sortable: true
        },
        {
          text: 'Beschreibung',
          align: 'left',
          class: 'text-xs-left',
          sortable: true,
          value: 'title',
          type: 'i18nTitle'
        }
      ]
    }
  },
  methods: {
    getDateTime: function (str) {
      return new Date(str).toLocaleDateString('de-DE') + ' ' + new Date(str).toLocaleTimeString('de-DE')
    },
    getDate: function (str) {
      return new Date(str).toLocaleDateString('de-DE')
    },
    translate: function (n) {
      return Vue.i18n.translate(n)
    },
    keyUpHistory: function (evt) {
      if (evt.key === 'Enter') {
        this.addHistory()
      }
    },
    onChangeFrom (date) {
      console.log('onChangeFrom', date)
      const [year, month, day] = date.split('-')
      var d = new Date()
      d.setFullYear(year)
      d.setMonth(month - 1)
      d.setDate(day)
      d.setMinutes(0)
      d.setHours(0)
      d.setSeconds(0)
      console.log('onChangeFrom', d, day)
      this.dateFromObj = d
      let md = moment(d)
      this.dateFromPS = md.format('YYYY-MM-DD')
      this.dateFrom = d.toLocaleDateString('de-DE')
    },
    addHistory: function () {
      let d = new Date(this.dateFromObj.getTime())
      d.setMinutes(this.minute)
      d.setHours(this.hour)
      console.log('addHistory', this.historyText, this.dateFrom, d.getTime())
      let cmp = this
      let dp = {
        history: cmp.historyText,
        historyTime: d.getTime()
      }
      this.currentItem.history.push({
        created: d.getTime(),
        title: cmp.historyText
      })
      Vue.prototype.$dms.appendStorageItemHistory(this.currentItem.guid, dp, cmp.reload)
    },
    open: function (currentItem) {
      this.currentItem = currentItem
      let i = 0
      for (i = 0; i < 23; i++) {
        this.hours.push(i)
      }
      for (i = 0; i < 59; i++) {
        this.minutes.push(i)
      }
      let d = new Date()
      this.minute = d.getMinutes()
      this.hour = d.getHours()
      d.setMinutes(0)
      d.setDate(1)
      d.setHours(0)
      d.setSeconds(0)
      this.dateFromObj = d
      this.dateFrom = d.toLocaleDateString('de-DE')
      let md = moment(d)
      this.dateFromPS = md.format('YYYY-MM-DD')
      this.historyText = ''
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/tabs/TabHistory.vue